<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">Trucking Companies</h2>
        <h2 v-show="trash">Trucking Companies - Trash</h2>
			</b-col>
		</div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid>
            <!-- Main table element -->
            <b-row>
							<b-col lg="4" md="6" xs="12" class="my-1">
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<b-form-input v-model="filter" placeholder="Search" />
										<b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
									</div>
								</div>
							</b-col>
							<b-col v-if="role==='super_admin'" lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashTC()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashTC()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
							<b-col lg="5" md="6" xs="12">
								<b-button @click="newTCModal" variant="primary" class="active mb-3 pull-right">Add Trucking Company</b-button>
							</b-col>
						</b-row>
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                 <p class="text-center">
                   <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                 </p>
              </b-col>
            </b-row>
            <b-table class="animated fadeIn" v-else striped hover bordered show-empty
                     stacked="md"
                     :items="items"
                     :fields="fieldsTh"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
                     @row-clicked="rowClicked"
            >

            </b-table>
            <b-row>
							<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
								<div class="input-group mb-3">
									<div class="input-group-prepend"> </div>
									<b-select :options="pageOptions" v-model="perPage" />
								</div>
							</b-col>
							<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
								<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
							</b-col>
						</b-row>
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New Trucking Company Modal-->
    <b-modal title="New Trucking Company" v-model="newTC" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
           <b-form-group :label-cols="4" id="L1" label="Company Name" label-for="CompanyNameID" horizontal>
              <b-form-input id="CompanyNameID" type="text" v-model="model.trucking_company_name"></b-form-input>
            </b-form-group>

            <b-form-group v-if="role === 'super_admin' && energycompaniesselect.length > 0" :label-cols="4" id="L2" label="Energy Companies" label-for="loadLocationsID" horizontal>
              <b-form-checkbox-group value-field="id" text-field="company_name"  class="custom-checkboxes" :options="energycompaniesselect" name="Checkboxes2" plain v-model="model.energy_company_id" @input="ECChange"></b-form-checkbox-group>
              <b-form-checkbox style="margin-top: 15px;" v-model="ecAllSelected" :indeterminate="indeterminateEC" aria-describedby="" aria-controls="" plain @change="ECToggleAll">
                {{ ecAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox>
            </b-form-group>
            <b-form-group  :label-cols="4" id="L17" label="Truck Printing" label-for="ULID0" horizontal>
							<b-form-checkbox 
                  		id="checkbox"
											class="custom-checkboxes"
                      style="margin-top: 13px;"
                  		v-model="model.in_truck_printing" 
              ></b-form-checkbox>	
					</b-form-group>	
            <b-form-group  :label-cols="4" id="L17" label="Multi Loads" label-for="ULID" horizontal>
							<b-form-checkbox 
                  		id="checkbox"
											class="custom-checkboxes"
                      style="margin-top: 13px;"
                  		v-model="model.multiloads" 
              ></b-form-checkbox>	
					</b-form-group>	
            <!-- Added 18/02/2019 -->
            <b-form-group v-if="operatingareasselect.length > 0" :label-cols="4" id="L3" label="Operating Areas" label-for="OaID" horizontal>
              <b-form-checkbox-group value-field="id" text-field="name" class="custom-checkboxes" :options="operatingareasselect" name="Checkboxes2" plain v-model="model.operating_areas_id" @input="OAChange"></b-form-checkbox-group>
              <b-form-checkbox style="margin-top: 15px;" v-model="oaAllSelected" :indeterminate="indeterminateOA" aria-describedby="" aria-controls="" plain @change="OAToggleAll">
                {{ oaAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox>
            </b-form-group>

            <b-form-group v-if="loadlocationsselect.length > 0" :label-cols="4" id="L4" label="Load Locations" label-for="LoadLocationID" horizontal>
              <b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="loadlocationsselect" name="Checkboxes2" plain disabled v-model="model.load_locations_id" ></b-form-checkbox-group>
             <!-- <b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll"> @input="LLChange"
                {{ llAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox> -->
            </b-form-group>

            <b-form-group v-if="unloadlocationsselect.length > 0" :label-cols="4" id="L5" label="Unload Locations" label-for="UnLoadLocationID" horizontal>
              <b-form-checkbox-group class="custom-checkboxes" :options="unloadlocationsselect" name="Checkboxes2" plain disabled v-model="model.unload_locations_id" ></b-form-checkbox-group>
          <!--    <b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ULToggleAll"> @input="ULChange"
                {{ ulAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox> -->
            </b-form-group>
            <b-form-group :label-cols="4" id="L11" label="Address" label-for="address" horizontal>
              <b-form-textarea id="address" type="text" v-model="model.address" rows="3" max-rows="8"></b-form-textarea>
            </b-form-group>
            <b-form-group :label-cols="4" id="L12" label="Dispatch Title" label-for="dispatch_title" horizontal>
              <b-form-input id="dispatch_title" type="text" v-model="model.dispatch_title"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L13" label="Phone Number #1" label-for="phone_number1" horizontal>
              <b-form-input id="phone_number1" placeholder="##########" v-mask="'##########'" type="tel" autocomplete="off" v-model="model.phone_number1"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L14" label="Phone Number #2" label-for="phone_number2" horizontal>
              <b-form-input id="phone_number2" placeholder="##########" v-mask="'##########'" type="tel" autocomplete="off" v-model="model.phone_number2"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L16" label="Alternate Name" label-for="alternate_name" horizontal>
              <b-form-input id="alternate_name" type="text" v-model="model.alternate_name"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="3" id="L15" label="Company Logo" label-for="file01" horizontal>
				      <input type="file" id="files" accept="image/*" ref="file" v-on:change="handleFileUpload()" />
			      </b-form-group>

            <!-- End Added  -->
        </b-col>
      </b-row>
      <b-row v-if="progress">
                    <b-col v-if="load_logo==='Saving Logo file.....'" md="10">
                        <h5 class="mt-3" > <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i> {{load_logo }}</h5>
                        <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress>
                    </b-col>
                    <b-col v-else md="10">
                        <h5 class="mt-3" >{{load_logo }}</h5>
                        <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress>
                    </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
              <b-embed v-if="url!=''"
                type="iframe"
                aspect="16by9"
                allowfullscreen
                frameborder="0"
                :src=url
            ></b-embed>
        </b-col> 
      </b-row>
      <b-row>
				<b-col cols="12">
            <b-form-group  :label-cols="4" id="L6" label="Hazards:" label-for="hzID" horizontal>
              <b-form-checkbox-group v-if="hazards.length>0" value-field="id" text-field="name"  class="custom-checkboxes" :options="hazards" name="Checkboxes2" plain v-model="model.hazard_id"  @input="HZChange"></b-form-checkbox-group>
              <p v-else>No Hazards have been added</p>
              <b-form-checkbox v-if="hazards.length>0" style="margin-top: 15px;" v-model="hzAllSelected" :indeterminate="indeterminateHZ" aria-describedby="" aria-controls="" plain @change="HZToggleAll">
                {{ hzAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox>
            </b-form-group>						

            <b-form-group  :label-cols="4" id="L6" label="Controls:" label-for="ctlID" horizontal>
              <b-form-checkbox-group v-if="controls.length>0" value-field="id" text-field="name"  class="custom-checkboxes" :options="controls" name="Checkboxes2" plain v-model="model.control_id"  @input="CTLChange"></b-form-checkbox-group>
              <p v-else>No controls have been added</p>
              <b-form-checkbox v-if="controls.length>0" style="margin-top: 15px;" v-model="ctlAllSelected" :indeterminate="indeterminateCTL" aria-describedby="" aria-controls="" plain @change="CTLToggleAll">
                {{ ctlAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox>
            </b-form-group>						
				</b-col>
			</b-row>


      <b-row  style="padding: 15px 0 0 15px">

			</b-row>

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="newTC=false" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveTC" class="float-right">Save</b-btn>
      </div>

    </b-modal>
    <!-- End New Trucking Company Modal-->
    <!-- Table Config-->
    <b-modal title="Config Table" v-model="configTable" ok-variant = "primary">
      <b-row>
        <b-col cols="12">
          <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
              <b-form-checkbox value="id" :disabled="true" @change="actionField('id')">Company ID</b-form-checkbox>
              <b-form-checkbox value="name" :disabled="true" @change="actionField('name')">Company Name</b-form-checkbox>
              <b-form-checkbox value="drivers" @change="actionField('drivers')">Drivers</b-form-checkbox>
              <b-form-checkbox value="trucks" @change="actionField('trucks')">Trucks</b-form-checkbox>
              <b-form-checkbox value="operating_areas" @change="actionField('operating_areas')">Assign. Operating Areas</b-form-checkbox>
          </b-form-checkbox-group>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Table Config-->
  </div>
</template>

<script>
  import tc_service from './tc_service'
  import {apiDomain} from '../../config'
  import axios from 'axios'

  const items = []
  const fields = ['details','id','name','drivers','trucks','operating_areas','actions']
  export default {
    name: 'truckingCompanies',
    created: function () {
      localStorage.removeItem("ftPage");
      localStorage.removeItem("targetsaPage");
      localStorage.removeItem("tpPage");
      localStorage.removeItem("oasaPage");
      localStorage.removeItem("oaPage");
      localStorage.removeItem("reportPage");
      localStorage.removeItem("rolesPage");
      localStorage.removeItem("locationPage");
      localStorage.removeItem("servicePage");
      localStorage.removeItem("truckPage");
      localStorage.removeItem("taPage");
      localStorage.removeItem("tasaPage");
      localStorage.removeItem("userPage");
      if (!localStorage.tcPage) {
          localStorage.tcPage = 0;
      }
      this.getAll()
    },
    data () {
      return {
        trash: false,
				dpdt: 'Active',
        energycompaniesselect: [],
        model: {
          trucking_company_name : '',
          energy_company_id     : [],
          // Added  19/02/2019
          operating_areas_id    : [],
          load_locations_id     : [],
          unload_locations_id   : [],
          multiloads            : false,
          address               : '',
          dispatch_title        : '',
          phone_number1         : '',
          phone_number2         : '',
          company_logo          : '',
          alternate_name        : '',
          in_truck_printing     : false,
          hazard_id					    : [],
				  control_id					  : [],
          // End Added
        },
        indeterminateEC: false,
				ecAllSelected: false,
        loadingData: true,
        items: items,
        newTC: false,
        configTable: false,
        companyName: '',
        companyId: null,
        fields: fields,
        fieldsTh: [
          { key: 'id', label: 'ID', sortable: true },
          { key: 'name', label: 'Company Name', sortable: true },
        ],
        currentPage: parseInt(localStorage.tcPage),
        perPage: 25,
        totalRows: items.length,
        pageOptions: [ 25, 50, 100 ],
        sortBy: 'name',
        sortDesc: false,
        filter: null,
        modalInfo: { title: '', content: '' },
        modalEdit: { title: ''},
        selectedItems: ['id','name','drivers','trucks','operating_areas'],
        savebtn:true,
        // Added 19/02/2019
        operatingareasselect  : [],
        indeterminateOA       : false,
        oaAllSelected         : false,
        loadlocationsselect   : [],
        indeterminateLL       : false,
        llAllSelected         : false,
        unloadlocationsselect : [],
        indeterminateUL       : false,
        ulAllSelected         : false,
        role                  : '',
        file                  : '',
        url                   : '',
        load_logo             : 'Saving Logo file.....',
        uploadPercentage      : 0,
        progress              : false,
        hazards						    : [],
				controls					    : [],
				indeterminateHZ				: false,
				hzAllSelected				  : false, 
				indeterminateCTL   		: false,
				ctlAllSelected				: false, 
        updateData            : null,
        file_64               : '',
        // End Added
      }
    },
    computed: {
      sortOptions () {
        // Create an options list from our fields
        return this.fieldsTh
          .filter(f => f.sortable)
          .map(f => { return { text: f.label, value: f.key } })
      }
    },
    methods: {
      ECChange() {
        // Added 20/02/2019
        if (this.role==='super_admin') {
            let energy_companies      = this.energycompaniesselect
            let energy_companies_id   = this.model.energy_company_id
            this.loadlocationsselect  = []
            this.unloadlocationsselect  = []
            this.operatingareasselect = []
            let new_loadlocations     = []
            let new_oa                = []
            let new_unloadlocations     = []

            for (var i = 0; i < energy_companies_id.length; i+=1) {
              let energy_company_index = energy_companies.map(o => o.id).indexOf(energy_companies_id[i])
              if (energy_company_index > -1) {
                  let loadlocations = energy_companies[energy_company_index].loads_locations
                  let operatingarea = energy_companies[energy_company_index].operating_area
                  let unloadlocations = energy_companies[energy_company_index].unloads_locations
                  loadlocations.forEach(function(e){
                    if (new_loadlocations.length != 0) {
                        if (new_loadlocations.map(o => o.id).indexOf(e.id)<0) {
													new_loadlocations.push(e)
												} 
                    } else {
                      new_loadlocations.push(e)
                    } 
                  })
                  unloadlocations.forEach(function(e){
                    if (new_unloadlocations.length != 0) {
                        if (new_unloadlocations.map(o => o.id).indexOf(e.id)<0) {
													new_unloadlocations.push(e)
												} 
                    } else {
                      new_unloadlocations.push(e)
                    } 
                  })
                  operatingarea.forEach(function(e){
                    if (new_oa.length != 0) {
                        if (new_oa.map(o => o.id).indexOf(e.id)<0) {
													new_oa.push(e)
												} 
                    } else {
                      new_oa.push(e)
                    } 
                  })
						  } else {
                  new_loadlocations = []
                  new_unloadlocations = []
                  new_oa            = []
              }
            }
            this.loadlocationsselect  =new_loadlocations
            // this.unloadlocationsselect  =new_unloadlocations
            this.operatingareasselect =new_oa  
            if (new_unloadlocations.length !=0) {
								    this.unloadlocationsselect = new_unloadlocations.map((item) => {
									    return {
										    'value' : item.id,
										    'text'  : item.legal_location.charAt(0).toUpperCase() + item.legal_location.slice(1).toLowerCase()
									    }
							      })
            }
          /// operating areas
          let operating_area   		= this.operatingareasselect
          let operating_area_id   = this.model.operating_areas_id
          if (operating_area_id === true) {
						return
          }
          let new_oa_id = []
          operating_area_id.forEach(function(e){
            if (operating_area.length != 0) {
              if (operating_area.map(o => o.id).indexOf(e)>-1) {
								new_oa_id.push(e)
              } 
            }
          })
          this.model.operating_areas_id = new_oa_id
          /// Load
          let loadlocations = this.loadlocationsselect 
          if (this.model.load_locations_id==null) {
             this.model.load_locations_id=[]
          }
          let loadlocations_id = this.model.load_locations_id
          let new_ll_id = []
          loadlocations_id.forEach(function(e){
            if (loadlocations.length != 0) {
              if (loadlocations.map(o => o.id).indexOf(e)>-1) {
								new_ll_id.push(e)
              } 
            }
          })
          this.model.load_locations_id =  new_ll_id  
          /// Unload
          let unloadlocations = this.unloadlocationsselect 
          if (this.model.unload_locations_id==null) {
             this.model.unload_locations_id=[]
          }
          let unloadlocations_id = this.model.unload_locations_id
          let new_ul_id = []
          unloadlocations_id.forEach(function(e){
            if (unloadlocations.length != 0) {
              if (unloadlocations.map(o => o.id).indexOf(e)>-1) {
								new_ul_id.push(e)
              } 
            }
          })
          this.model.unload_locations_id =  new_ul_id
          // End Added
				  if (this.model.energy_company_id.length === 0) {
					  this.indeterminateEC = false
					  this.ecAllSelected = false
				  } else if (this.model.energy_company_id.length === this.energycompaniesselect.length) {
					  this.indeterminateEC = false
					  this.ecAllSelected = true
				  } else {
					  this.indeterminateEC = true
					  this.ecAllSelected = false
          }
        }
			},
      ECToggleAll(checked) {
				this.model.energy_company_id = checked ? this.energycompaniesselect.map(item => {
					return item.id
				}) : []
      },
    // Added 19/02/2019
      ULChange() {
        if (this.model.unload_locations_id==null) {
          this.model.unload_locations_id=[]
        }
				if (this.model.unload_locations_id.length === 0) {
					this.indeterminateUL = false
					this.ulAllSelected = false
				} else if (this.model.unload_locations_id.length === this.unloadlocationsselect.length) {
					this.indeterminateUL = false
					this.ulAllSelected = true
				} else {
					this.indeterminateUL = true
					this.ulAllSelected = false
				}
			},
      ULToggleAll(checked) {
				this.model.unload_locations_id = checked ? this.unloadlocationsselect.map(item => {
					return item.value
				}) : []
            },
      LLChange() {
        if (this.model.load_locations_id==null) {
          this.model.load_locations_id=[]
        }
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false
					this.llAllSelected = false
				} else if (this.model.load_locations_id.length === this.loadlocationsselect.length) {
					this.indeterminateLL = false
					this.llAllSelected = true
				} else {
					this.indeterminateLL = true
					this.llAllSelected = false
        }
			},
      LLToggleAll(checked) {
				this.model.load_locations_id = checked ? this.loadlocationsselect.map(item => {
					return item.id
				}) : []
      },
      OAChange() {
          // Additional
					let operating_area   		= this.operatingareasselect
          let operating_area_id   = this.model.operating_areas_id
          let load_locations      = this.loadlocationsselect
          let load_locations_id   = this.model.load_locations_id 
					if (operating_area_id === true) {
						return
          }
					let ll = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].load_locations.map(o => o.id)
						}
					}) 
          let ll1=[]
          ll.flat().forEach(function(element) {
                let ll_index = load_locations.map(o => o.id).indexOf(element)
                if (ll_index >= 0) {
		                ll1.push(element)
						    }
          })
          
          let ll2=[...new Set(ll1)]   // quita valores duplicados
					this.model.load_locations_id    = Array.prototype.concat.apply([], ll2)
					
          let ul = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].unload_locations.map(o => o.id)
						}
          })
					this.model.unload_locations_id  = Array.prototype.concat.apply([], ul)
          // End
        if (this.model.operating_areas_id==null) {
          this.model.operating_areas_id=[]
        }
				if (this.model.operating_areas_id.length === 0) {
					this.indeterminateOA = false
					this.oaAllSelected = false
				} else if (this.model.operating_areas_id.length === this.operatingareasselect.length) {
					this.indeterminateOA = false
					this.oaAllSelected = true
				} else {
					this.indeterminateOA = true
					this.oaAllSelected = false
        }
		  },
      OAToggleAll(checked) {
				this.model.operating_areas_id = checked ? this.operatingareasselect.map(item => {
					return item.id
				}) : []
      },
    // End Added
      newTCModal() {

        this.savebtn=false
        this.newTC = true
        if (this.role==='super_admin') {
          this.model = {
			      trucking_company_name: '',
            energy_company_id: [],
            operating_areas_id    : [],
            load_locations_id     : [],
            unload_locations_id   : [],
            multiloads            : false,
            address               : '',
            dispatch_title        : '',
            phone_number1         : '',
            phone_number2         : '',
            company_logo          : '',
            alternate_name        : '',
            in_truck_printing     : false,
            hazard_id   : [],
            control_id     : [],
		      }
          this.file                = ''
          this.url                 = ''
          this.loadlocationsselect = []
          this.progress            = false 
				    this.indeterminateHZ				    = false
				    this.hzAllSelected				      = false 
				    this.indeterminateCTL   			  = false
				    this.ctlAllSelected				      = false 
        } else if (this.role==='operations_manager') {
            this.model.trucking_company_name  = ''
            this.model.operating_areas_id     = []
            this.model.load_locations_id      = []
            this.model.unload_locations_id    = []
            this.model.multiloads             = false
        }
      },
      trashTC() {
				this.trash = !this.trash
				this.dpdt = this.trash ? "Trash" : "Active"
				this.getAll()
				this.loadingData = true
			},
      rowClicked(row) {
        localStorage.tcPage = this.currentPage;
				if(!this.trash) {
          localStorage.setItem('xyz', row.id)
					this.$router.push('/trucking_company/' + row.id + '/')
				} else {
					this.restoreTC(row.id)
				}
			},
      onFiltered (filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        	this.currentPage = parseInt(localStorage.tcPage)
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      getAll () {
        this.loadingData = true
        tc_service.getAll()
          .then(data => {
                if (data[0] == 'success') {
                  this.items = data[1].filter(o => o.status_id == (this.trash ? 2 : 1))
                  this.energycompaniesselect    = [] //data[2].energy_companies
                  /*let unload_locations_map      = data[2].unload_locations
						      if (unload_locations_map.length !=0) {
								    this.unloadlocationsselect = unload_locations_map.map((item) => {
									    return {
										    'value' : item.id,
										    'text'  : item.legal_location.charAt(0).toUpperCase() + item.legal_location.slice(1).toLowerCase()
									    }
							      })
                  } */
                  this.hazards = [] // data[2].hazards
						      this.controls = [] // data[2].controls
                  this.role = data[3]
                  /*if (this.role==='operations_manager') {
                      this.operatingareasselect   = this.energycompaniesselect[0].operating_area
                      //this.unloadlocationsselect  = this.energycompaniesselect[0].unloads_locations
                      this.loadlocationsselect    = this.energycompaniesselect[0].loads_locations
                      if (this.energycompaniesselect !=0) {
                        this.model.energy_company_id = this.energycompaniesselect.map(item => {
					                  return item.id
                        })
                      }
                  } */
                  this.get_attributtes()
                  // End Added
                } else {
                  this.items = []
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      okToSave() {
				if (this.model.trucking_company_name === undefined || this.model.trucking_company_name.trim().length == 0) {
					this.$swal('Alert!', 'Trucking Company Name can not be empty', 'warning')
					return false
				}

				return true
			},
      saveTC () {
        if (!this.okToSave()) {
					return
				}
        this.savebtn=true
        this.saveLogo ()
        this.savebtn=false
      },
      restoreTC(id) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to restore this Trucking Company?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
          reverseButtons: true
				}).then((result) => {
					if (result.value) {
						tc_service.restore(id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.filter = ''
									this.trash = false
									this.getAll()
									this.loadingData = true
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
      handleFileUpload() {
        this.file = this.$refs.file.files[0]
        this.model.company_logo = this.file['name']
        let url = window.URL.createObjectURL(this.file)
        this.url = url
				setTimeout(() => window.URL.revokeObjectURL(url), 100)
        
        let reader = new FileReader();

        reader.readAsDataURL(this.file);

        reader.onload = function() {
            localStorage.setItem('file_64', reader.result)      
          return 
        };
      },
      saveLogo () {
        let file_64 = ''
        if ('file_64' in  localStorage) {
            file_64 = localStorage.getItem('file_64')
        }
        let model = {
            name: this.model.trucking_company_name,
            energy_companies: this.model.energy_company_id.map(item => {
              return {
                id: String(item)
                }
            }),
            operating_areas: this.model.operating_areas_id.map(item => {
              return {
                id: String(item)
                }
            }),
            load_locations: this.model.load_locations_id.map(item => {
              return {
                id: String(item)
                }
            }),
            unload_locations: this.model.unload_locations_id.map(item => {
              return {
                id: String(item)
                }
            }),
            multiloads:this.model.multiloads,
            address         :this.model.address,
            dispatch_title  :this.model.dispatch_title,
            phone_number1   :this.model.phone_number1,
            phone_number2   :this.model.phone_number2,
            alternate_name  :this.model.alternate_name,
            company_logo    :this.model.company_logo,
            in_truck_printing     : this.model.in_truck_printing,
            hazard_id				   : this.model.hazard_id,
					  control_id			   : this.model.control_id,
            file_64            : file_64

        }
        const json = JSON.stringify(model);
        const blob = new Blob([json], {
          type: 'application/json'
        })
        let formData = new FormData()
        formData.append("document", blob)
        formData.append('file', '')
        this.uploadPercentage   = 0
        if (this.file!='') {
          this.progress           = true 
        }     
        this.load_logo           = 'Saving Logo file.....'
        
        this.save_logo ( formData )
      },
      save_logo ( formData ) {

			  axios.post(apiDomain + '/trucking_company/create/', formData, { headers: {
				  'Content-Type': 'multipart/form-data',
			    'token': localStorage.getItem('access_token')
        },
        onUploadProgress: ( progressEvent ) => {
            this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
        }
        })
				  .then((response) => {
            let data = response.data
            if (data.status == 'success') {
              this.load_logo           = 'Logo file saved'
              localStorage.removeItem('file_64');
              this.$swal(data.status, data.message, data.status)
              this.newTC = false
              this.getAll() 
            } else {
                this.load_logo        = 'Saving Logo file.....',
                this.uploadPercentage= 0,
                this.progress        = false
                this.model.company_logo       = ''
                this.url             = ''
                this.file            = ''
                this.$swal(data.status, data.message, data.status)
            }
				  })
				  .catch((error) => {
              this.load_logo        = 'Saving Logo file.....',
              this.uploadPercentage= 0,
              this.progress        = false
              this.$swal('Error', 'Server not response. ' + error, 'error')
				  })
	    },
      HZChange() {
				if (this.model.hazard_id.length === 0) {
					this.indeterminateHZ = false
					this.hzAllSelected = false
				} else if (this.model.hazard_id.length === this.hazards.length) {
					this.indeterminateHZ = false
					this.hzAllSelected = true
				} else {
					this.indeterminateHZ = true
					this.hzAllSelected = false
				}
			},
			HZToggleAll(checked) {
				this.model.hazard_id = checked ? this.hazards.map(item => {
					return item.id
				}) : []
			},
			CTLChange() {
				if (this.model.control_id.length === 0) {
					this.indeterminateCTL = false
					this.ctlAllSelected = false
				} else if (this.model.control_id.length === this.controls.length) {
					this.indeterminateCTL = false
					this.ctlAllSelected = true
				} else {
					this.indeterminateCTL = true
					this.ctlAllSelected = false
				}
			},
			CTLToggleAll(checked) {
				this.model.control_id = checked ? this.controls.map(item => {
					return item.id
				}) : []
			},
      get_attributtes() {
				tc_service.get_att()
					.then(data => {
						if (data.status === 'success') {
							this.updateData 		= data.update_data
							this.hazards 			= this.updateData.hazards
							this.controls 			= this.updateData.controls
							this.energycompaniesselect 	= this.updateData.energy_companies
							//this.operatingareasselect		= this.updateData.operating_areas_all
							//this.loadlocationsselect  		= this.updateData.load_locations_all
							//this.unloadlocationsselect  	= this.updateData.unload_locations_all
              if (this.role==='operations_manager') {
                      this.operatingareasselect   = this.energycompaniesselect[0].operating_area
                      let new_unloadlocations  = this.energycompaniesselect[0].unloads_locations
                      this.unloadlocationsselect  = []
                      if (new_unloadlocations.length !=0) { 
                          this.unloadlocationsselect = new_unloadlocations.map((item) => {
                            return {
                              'value' : item.id,
                              'text'  : item.legal_location.charAt(0).toUpperCase() + item.legal_location.slice(1).toLowerCase()
                            }
                          })
                      }
                      this.loadlocationsselect    = this.energycompaniesselect[0].loads_locations
                      if (this.energycompaniesselect !=0) {
                        this.model.energy_company_id = this.energycompaniesselect.map(item => {
					                  return item.id
                        })
                      }
                  }
						} else {
							this.$swal(data.status, data.message, data.status)
              				this.loadingData = false
              return
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/trucking_companies/trucking_companies.vue